import React, { useState } from 'react';
import SuggestionCard from './SuggestionCard';

const ImproveTab = ({ result, resultIdx, fixStates, onAcceptFix, onManualRewrite }) => {
  const fixes = result.fixPanel || result.fixes || [];
  const appliedFixes = fixStates[resultIdx]?.appliedFixes || new Set();
  const [dismissed, setDismissed] = useState(new Set());
  const [manualText, setManualText] = useState('');

  const handleDismiss = (i) => {
    setDismissed((prev) => {
      const next = new Set(prev);
      next.add(i);
      return next;
    });
  };

  const handleAiApply = () => {
    if (!manualText.trim() || !onManualRewrite) return;
    onManualRewrite(resultIdx, 'freeform', manualText);
    if (onAcceptFix) onAcceptFix(resultIdx, 'freeform', true);
    setManualText('');
  };

  const visibleCount = fixes.filter((_, i) => !dismissed.has(i)).length;

  return (
    <div className="improve-tab">
      {fixes.length === 0 ? (
        <div className="improve-empty">
          <span className="improve-empty-icon">✦</span>
          <p>Improvement suggestions are generated during your session and are not stored with the document.</p>
          <p style={{ marginTop: '8px', fontSize: '12px', color: '#4E6385' }}>Re-generate this document to see actionable suggestions for this content.</p>
        </div>
      ) : visibleCount === 0 ? (
        <div className="improve-empty">
          <span className="improve-empty-icon">✓</span>
          <p>All suggestions handled.</p>
        </div>
      ) : (
        <div className="suggestion-list">
          {fixes.map((fix, i) => {
            if (dismissed.has(i)) return null;
            return (
              <SuggestionCard
                key={i}
                fix={fix}
                isApplied={appliedFixes.has(i)}
                onAccept={() => onAcceptFix(resultIdx, i, true)}
                onDismiss={() => handleDismiss(i)}
              />
            );
          })}
        </div>
      )}

      {/* No content exists on a failed doc to apply a manual edit against */}
      {!result.failed && (
        <div className="manual-edit-block">
          <label className="manual-edit-label">Manual Edit</label>
          <textarea
            className="manual-edit-textarea"
            placeholder="Describe a change in your own words..."
            rows={3}
            value={manualText}
            onChange={(e) => setManualText(e.target.value)}
          />
          <button
            className="manual-edit-btn"
            onClick={handleAiApply}
            disabled={!manualText.trim()}
          >
            Apply with AI
          </button>
        </div>
      )}
    </div>
  );
};

export default ImproveTab;
